import { Popover } from '@mui/material';
import styled, { css } from 'styled-components';

import Icon from '../Icon';

export const Root = styled.div`
  cursor: pointer;
`;
export const ButtonWrapper = styled.div`
  cursor: pointer;
`;
export const StyledPopover = styled(Popover)`
  .MuiPaper-root {
    padding: 4px;
      background-color: ${({ theme }) => theme.colors.background};
`;
export const PropertiesIcon = styled(Icon)<{ open: boolean }>`
  color: ${({ theme }) => theme.colors.textSecondary};
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.surfaceSecondary};
    color: ${({ theme }) => theme.colors.textPrimary};
  }

  ${({ open }) =>
    open &&
    css`
      background-color: ${({ theme }) => theme.colors.surfaceSecondary};
      color: ${({ theme }) => theme.colors.textPrimary};
    `}
`;
